import { render, staticRenderFns } from "./PublicationSubAreaOcdeTab.vue?vue&type=template&id=f6b5f190&scoped=true"
import script from "./PublicationSubAreaOcdeTab.vue?vue&type=script&lang=js"
export * from "./PublicationSubAreaOcdeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b5f190",
  null
  
)

export default component.exports